var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('Nav'),_c('Hero',{attrs:{"boldText":_vm.chosenBoldText,"heroText":_vm.chosenHeroText,"subText":_vm.chosenSubText,"buttonText":"Check it out","buttonLink":"/blog"}}),_c('Featured'),_c('About'),_c('Extra'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }